import { IConfig } from './config.interface';

// const isProd = (process.env.NODE_ENV || '').toLowerCase().startsWith('prod');
// const apiUrl = isProd ? 'https://api.dev.voltaage.io' : 'http://localhost:3000';
const apiUrl = process.env.REACT_APP_API_URL || 'MISSING_API_URL';

export const config: IConfig = {
	apiUrl,
	gaTrackingId: 'G-JFDVMSYNWJ',
	snackbarTimeout: 5000,
	lang: process.env.REACT_APP_LANG || 'en',
};
